/* eslint-disable @next/next/no-html-link-for-pages */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import cookies from "js-cookie";
import _ from "lodash";
import Link from "next/link";
import router from "next/router";
import { Button } from "components/button";
import { Ratings } from "components/ratings";
import { heartsIcon, newShowIcon, newVerifiedIcon } from "components/svgs";
import { useNotify } from "hooks";
import { likeSchool } from "services/school";
import { NewSchoolBannerContainer } from "styles/single-school/single-school.style";
import { Div } from "styles/typography";
import { getSession } from "utils/auth";

const SingleSchoolBanner = ({
   schoolData,
   open,
   openEnquiryModal,
   school,
   ratings,
   likes,
   views,
   refetch,
   slug,
}) => {
   const [isLikeLoading, setIsLikeLoading] = useState(false);
   const { notify } = useNotify();
   const { inSession } = getSession();
   const [likedSchool, setLikedSchool] = useState(false);

   useEffect(() => {
      const likedSchoolStorage = localStorage.getItem("edusko-like-school");
      const likedSchoolStorageId = localStorage.getItem("edusko-like-school-id");

      if (likedSchoolStorageId === schoolData?.data?.data?.id) {
         likedSchoolStorage === "true" ? setLikedSchool(true) : setLikedSchool(false);
      } else {
         setLikedSchool(false);
      }
   }, []);

   const averageRatings =
      ratings.length > 0
         ? Math.round(
              ratings?.reduce((a: number, b: Record<string, string>) => a + +b?.rating, 0) /
                 ratings.length
           )
         : 0;

   const handleLikeSchool = async (id: string) => {
      try {
         setIsLikeLoading(true);
         const response: any = await likeSchool(id as string);
         setLikedSchool(!likedSchool);
         localStorage.setItem("edusko-like-school", !likedSchool as unknown as string);
         localStorage.setItem("edusko-like-school-id", school?.id as unknown as string);
         notify({
            message: response.result.message || "Account successfully added!",
            variant: "success",
         });
         refetch();
      } catch (error: any) {
         notify({
            message: error.result.message || error.result.custom_message,
            variant: "error",
         });
      } finally {
         setIsLikeLoading(false);
      }
   };

   function handleSchoolRegistration() {
      if (inSession) {
         open();
      } else {
         cookies.set("edusko-school-redirect", "true");
         cookies.set("edusko-school-redirect-path", router.asPath);
         localStorage.setItem("edusko-school-redirect-trigger-name", JSON.stringify(school.name));
         router.push({
            pathname: "/signup",
            query: { from: `${router.pathname}`, slug: school.slug },
         });
      }
   }

   return (
      <NewSchoolBannerContainer>
         <div className="school-header-content">
            <div className="school-header-meta">
               <p className="school-header-name">{school?.name}</p>
               {school?.isVerified && (
                  <div className="school-header-verified">
                     {newVerifiedIcon}
                     <p className="school-header-verified-text">Verified</p>
                  </div>
               )}
            </div>
            <p className="school-about">{school?.aboutUs}</p>
            <div className="ratings show">
               <p>{averageRatings}</p>
               <Div display="flex" alignItems="center">
                  <Ratings readonly={true} value={averageRatings * 20} showToolTip={false} />
                  <p style={{ marginLeft: "10px", fontWeight: 400 }}>
                     ({ratings.length > 0 ? ratings?.length : 0} verified ratings)
                  </p>
               </Div>
            </div>
            <div className="buttons show">
               <Link href={`/school/${slug}?apply=yes`} passHref>
                  <div>
                     <Button
                        variant="primary"
                        onClick={handleSchoolRegistration}
                        disabled={!school?.hasBank}
                     >
                        Apply For Admission
                     </Button>
                  </div>
               </Link>
               <Link href={`/school/${slug}?enquiry=yes`} passHref>
                  <div>
                     <Button
                        variant="secondary"
                        onClick={openEnquiryModal}
                        style={{ color: "#3678E5" }}
                     >
                        Make Enquiry
                     </Button>
                  </div>
               </Link>

               <div>
                  <Button
                     variant="link"
                     onClick={() => router.push("/finance-loan-application")}
                     style={{ color: "#fff", textDecoration: "underline" }}
                  >
                     Access Tuition Finance
                  </Button>
               </div>
            </div>
            {/* <Div display="flex" alignItems="center">
               {askAIIcon}
               <Link href={`/ask-ai/${slug}`} passHref>
                  <Button
                     variant="link"
                     // onClick={() => router.push("/finance-loan-application")}
                     style={{
                        color: "#fff",
                        textDecoration: "underline",
                        margin: "1rem",
                     }}
                  >
                     Ask Edusko AI
                  </Button>
               </Link>
            </Div> */}
         </div>
         <div className="logo-div">
            <div className="school-logo">
               <img src={school?.logo} alt="school-logo" />
            </div>
            <div>
               <div className="like-meta">
                  <div className="like-meta-div">
                     {newShowIcon}
                     <p>{views}</p>
                  </div>
                  <div className="hr" />
                  <div
                     className="like-meta-div"
                     style={{ cursor: "pointer" }}
                     role="button"
                     tabIndex={0}
                     onKeyDown={() => handleLikeSchool(school?.id)}
                     onClick={() => handleLikeSchool(school?.id)}
                  >
                     {isLikeLoading ? (
                        <CircularProgress color="primary" thickness={5} size={13} />
                     ) : (
                        <>
                           {heartsIcon}
                           <p>{likes}</p>
                        </>
                     )}
                  </div>
               </div>
            </div>
         </div>
         <div className="ratings hide">
            <p>{averageRatings}</p>
            <Div display="flex" alignItems="center">
               <Ratings readonly={true} value={averageRatings * 20} showToolTip={false} />
               <p style={{ marginLeft: "10px", fontWeight: 400 }}>
                  ({ratings.length > 0 ? ratings?.length : 0} verified ratings)
               </p>
            </Div>
         </div>
         <div className="buttons hide">
            <Link href={`/school/${slug}?apply=yes`} passHref>
               <div>
                  <Button
                     variant="primary"
                     onClick={handleSchoolRegistration}
                     disabled={!school?.hasBank}
                  >
                     Apply For Admission
                  </Button>
               </div>
            </Link>
            <Link href={`/school/${slug}?enquiry=yes`} passHref>
               <div className="last-child">
                  <Button
                     variant="secondary"
                     onClick={openEnquiryModal}
                     style={{ color: "#3678E5" }}
                  >
                     Make Enquiry
                  </Button>
               </div>
            </Link>
         </div>
         <div className="buttons hide">
            <Button
               variant="link"
               onClick={() => router.push("/finance-loan-application")}
               style={{ color: "#fff", textDecoration: "underline" }}
            >
               Access Tuition Finance
            </Button>
         </div>
      </NewSchoolBannerContainer>
   );
};

export default SingleSchoolBanner;
